(function () {
  'use strict';

  angular
    .module('fdpViolationReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('fdpViolationReport', {
        url: '/fdp-violation-report',
        views: {
          'fdpViolationReportView': {
            templateUrl: 'fdp-violation-report/views/fdp-violation-report.tpl.html',
            controller: 'FdpViolationReportCtrl',
            controllerAs: 'fdpViolationReport'
          }
        }
      });
  }
}());
